import React from 'react'
import clsx from 'clsx'
import style from './style.module.scss'
import { LiveMatchPostFormatted } from '../../../types'
import { useStatsPerformMatch } from '../../../contexts/StatsPerformMatchesContext'
import { flagUrl } from '../../../shared/utils'
import { formatToDayJsDate } from '../../../utils/statsperform/statsperformUtils'
import { LiveMatchItem } from '../LiveMatchItem'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { useIgnoredMobileLiveMatch } from '../../../hooks/competitions/useIgnoredMobileLiveMatch'
import { useStatsPerformContestantsData } from '../../../hooks/useStatsPerformContestantsData'

const Item = ({ matchFormatted }: { matchFormatted: LiveMatchPostFormatted }) => {
    const bodyClassList = document.body.classList

    const { ignoredLiveMatch, addIgnoredLiveMatch } = useIgnoredMobileLiveMatch()
    const match = useStatsPerformMatch(matchFormatted.statsperformid)
    const { homeContestant, awayContestant } = useStatsPerformContestantsData(
        matchFormatted.statsperformid,
    )

    const canDisplay = match?.data?.matchInfo && homeContestant && awayContestant // && match?.data?.liveData

    const isCurrentMatchPage =
        bodyClassList.contains('single-live_match') &&
        bodyClassList.contains(`postid-${matchFormatted.post_id}`)

    if (!canDisplay || isCurrentMatchPage) return null

    const isMatchIgnored = ignoredLiveMatch.includes(matchFormatted.post_id)

    return (
        <div className={clsx(style.item, isMatchIgnored && style.ignored)}>
            <div
                className={style.close}
                onClick={() => addIgnoredLiveMatch(matchFormatted.post_id)}
            >
                <CloseIcon />
            </div>

            <LiveMatchItem
                href={matchFormatted.link}
                title={`${match!.data!.matchInfo.competition.name}`}
                error={match.error}
                homeName={''}
                homeIcon={flagUrl(homeContestant.logo)}
                homeScore={match.data?.liveData?.matchDetails.scores?.final?.home}
                awayName={''}
                awayIcon={flagUrl(awayContestant.logo)}
                awayScore={match.data?.liveData?.matchDetails.scores?.final?.away}
                status={match.data?.liveData?.matchDetails.matchStatus ?? 'Fixture'}
                date={formatToDayJsDate(match.data!.matchInfo)}
                className={style.link}
            />
        </div>
    )
}

export const LiveMatchesItemsMobile = ({ liveMatchs }: { liveMatchs: LiveMatchPostFormatted[] }) =>
    liveMatchs ? (
        <div className={style.mobileContainer}>
            {liveMatchs.map((x) => (
                <Item key={x.post_id} matchFormatted={x} />
            ))}
        </div>
    ) : null
